<template>
  <section>
    <div class="container-fluid">
      <div class="blur">
         
        <div
          class="img-bgg"
          v-bind:style="{
            'background-image':
              'url(https://pic.imamhussain.org/images/large/' +user.cover +')',
          }"
        ></div>
      </div>
      <div class="row">
        <div class="col-md-1 layer"></div>
        <div class="col-md-10 layer">
          <div class="row justify-content-center">
             <div class="v-h"></div>
            <div class="col-md-12 dd-h"></div>
             <div class="col-md-12">
     <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="mt-3">
            <div class="u-up" v-if="user.length != 0">
               <img v-if="user.avatar!=null"
                           class="m-photo"
                                        :src="`https://pic.imamhussain.org/avatars/medium/${user.avatar}`" alt="user-avatar"
                                        style="object-fit: cover;">
                                    <img v-else
                                        :src="`https://ui-avatars.com/api/?name=${user.name}&length=1&bold=true`"
                                        alt="user-avatar" style="object-fit: cover;">
              <div class="upload-pro-title my-2">{{ user.name }}</div>
              <h6 class="u-baio" v-if="user.about && user.about.about != null">
                {{ user.about.about }}
              </h6>
              <div class="d-flex mb-3">
                <div class="mx-2 d-flex align-items-center">
                  <ion-icon name="download-outline" class="icon-c"></ion-icon>
                  <span class="d-p">مشاهدات {{user.views | abbr}}</span>
                </div>
                <div class="mx-2 d-flex align-items-center">
                  <ion-icon name="images-outline" class="icon-c"></ion-icon>
                  <span class="d-p">عدد الصور {{user.photosCount | abbr}}</span>
                </div>
              </div>
              <div class="d-flex mb-3" v-if="user.about && user.about.social != null">
                <a  class="mx-2" v-for="(social, name, index) in user.about.social" :key="index"  :href="social">
                  <i class="aw-size" :class="`fab fa-${name}`" v-if="social !=''"></i>
                </a>
              
              </div>
            </div>
          </div>
        </div>
      </div>
      <Gallery :user_id="this.$route.params.id" />
             </div>
          </div>
        </div>
        <div class="col-md-1 layer"></div>
      </div>
    </div>
    <div class="container overflow-hidden p-0">
 
    </div>
    
  </section>
</template>
<script>
import Gallery from "../../components/gallery.vue";
export default {
  components: {
    Gallery,
  },
  data() {
    return {
      user: [],
    };
  },
   filters: {
        abbr: function(num) {
            if (num > 1000) {
                return Math.floor(num/1000) + 'K';
            } else {
                return num;
            }
        }
    },
  methods: {
    fetchUser(){
      fetch(`https://pic.imamhussain.org/index.php/user/${this.$route.params.id}`)
        .then((res) => res.json())
        .then((res) => {
          this.user = res;
        });
    },
  },
  created() {
    if (this.$route.params.id) {
      this.fetchUser();
      this.$store.state.gallery.user_gallery = [];
      var page = 1;
      this.$store.dispatch("gallery/fetchUsergallery", {
        page,
        clear: true,
        user: this.$route.params.id,
      });
    }
  },
};
</script>
<style lang="scss" scoped>
  .blur{
   filter: blur(20px) !important;
  }
  .img-bgg{
    filter: blur(400px) !important;
  }
  .layer{
    // background-image: none !important;
  }

  .icon-c {
    color: rgb(95, 95, 95);
    width: 26px;
  }

  .aw-size {
    font-size: 24px;
    color: rgb(144, 141, 141);
  }
</style>
